import adminApiClient from '../../api/base/adminApiClient'

export interface Report {
  id: number
  review_id: number
  user_id: number
  reason: string
  description: string | null
  created_at: string
  updated_at: string
  user: {
    id: number
    username: string
    nickname: string
    profile_image: string | null
  } | null
  review: {
    id: number
    review_text: string | null // 한줄평 (nullable)
    user: {
      id: number
      username: string
      nickname: string
    } | null
    place: {
      id: number
      name: string
      address: string | null
    } | null
  } | null
}

export interface GetReportsResponse {
  data: Report[]
  current_page: number
  last_page: number
  per_page: number
  total: number
}

export interface GetReportsParams {
  page?: number
  per_page?: number
  search?: string
}

export const adminReportApi = {
  getReports: async (
    params?: GetReportsParams
  ): Promise<GetReportsResponse> => {
    const response = await adminApiClient.get<GetReportsResponse>(
      '/admin/reports',
      {
        params,
      }
    )
    return response.data
  },
}
